export const text = {
  publicBiographies: "Public Memorials",
  welcomeLifeLigacy: "Welcome to Life Legacy",
  createMemorial: "Create a Memorial",
  dashboardData:
    "Memorial page & obituary to share your loved ones story with friends & family.",
  biography: "Biography",
  assignTo: "Assign To",
  emailId: "Email ID",
  createdByMe: "Created By Me",
  themeName: "theme name",
  sendInvite: "Send Invite",
  email: "email",
  receiveInvite: "Receive Invite",
  myBiographies: "My Memorials",
  assignUserList: "Assign User List",
  allBiography: "All Biographies",
  dashboard: "Dashboard",
  unSaveBiography: "Unsave biography",
  saveBiography: "Save biography",
  areYouSureUnSaveBiography: "Are you sure want to unsave biography",
  areYouSureSaveBiography: "Are you sure want to save biography",
};
